<template>
	<el-row class="points-show">
		<!-- 顶部介绍栏 -->
		<el-col :span="24">
			<el-col :span="10">私定故事</el-col>
			<el-col :span="4" :offset="10">
				<el-button type="primary" size="mini" style="margin-left: 30px" @click="addStorage(1)" plain>
					创建故事<i class="el-icon-add"></i>
				</el-button>
			</el-col>
		</el-col>
		<el-divider></el-divider>
		<!-- 搜索栏 -->
		<el-row :gutter="20">
			<el-col :span="5">
				<div class="search-view">
					<div>显示状态：</div>
					<el-select placeholder="请选择" clearable size="mini" v-model="searchform.status">
						<el-option v-for="(item, index) in reviewStatus" :key="index" :label="item.title"
							:value="item.type" />
					</el-select>
				</div>
			</el-col>
			<el-col :span="5">
				<div class="search-view">
					<div>关键字：</div>
					<el-input size="mini" v-model="searchform.content" placeholder="请输入关键字" clearable />
				</div>
			</el-col>
			<el-col :span="1" :offset="9">
				<el-button plain size="mini" type="primary" style="margin-left: 10px" @click="search">搜索</el-button>
				<el-button plain style="margin-left: 30px" size="mini" type="primary" @click="Empty">清空</el-button>
			</el-col>
		</el-row>
		<!-- 数据渲染 -->
		<el-col :span="24">
			<el-table :data="tableData" :height="tableHeight">
				<el-table-column type="index" width="30"></el-table-column>
				<el-table-column prop="title" label="故事标题" />
				<el-table-column prop="content" label="故事内容" />
				<el-table-column label="素材图片">
					<template slot-scope="scope">
						<el-image :src="scope.row.pic + '?x-oss-process=image/resize,w_50'"
							style="width: 50px; height: 50px" fit="cover" :preview-src-list="[scope.row.pic]" />
					</template>
				</el-table-column>
				<el-table-column prop="status" label="显示状态">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.status == 0" type="success" size="mini">显示</el-tag>
						<el-tag v-if="scope.row.status == 1" type="warning" size="mini">隐藏</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="上传时间">
					<template slot-scope="scope">
						<span>{{ scope.row.createTime | formatDate }}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="300">
					<template slot-scope="scope">
						<el-button plain size="mini" type="primary" @click="PerfectStory(scope.row)">私定故事</el-button>
						<el-button plain size="mini" type="info" @click="addStorage(2, scope.row)">编辑</el-button>
						<el-button plain type="danger" size="mini" @click="delstoryItem(scope.row.id)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-col>
		<!-- 分页小组件 -->
		<el-col :span="24">
			<el-pagination small layout="total, sizes, prev, pager, next, jumper" :page-size="pageSize" :total="total"
				:current-page.sync="pageNum" @current-change="handleCurrentChange" @size-change="handleSizeChange"
				:page-sizes="pageSizes">
			</el-pagination>
		</el-col>
		<!-- 创建/编辑故事 -->
		<el-dialog :title="isadd == 1 ? '创建故事' : '修改故事'" :visible.sync="dialogVisible" :before-close="closeUpdate"
			width="30%">
			<!-- 新增计划 -->
			<template v-if="isadd == 1">
				<el-form :model="addform" label-position="right" label-width="120px">
					<el-form-item label="故事首图" prop="matImg">
						<el-button @click="chooseRadio(1)" type="primary" size="mini" style="margin-bottom: 10px;">
							图片库上传
						</el-button>
						<el-upload class="hide" :action="uploadUrl" :multiple="true" list-type="picture-card" :limit="1"
							:on-success="getPictrueURL" accept=".jpg,.png,.jpeg,.mp4,.avi" :file-list="fileList"
							:on-remove="handleRemove" :on-error="handleError">
							<i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
					<el-form-item label="故事标题:">
						<el-input size="mini" :rows="5" placeholder="请输故事标题" v-model="addform.title">
						</el-input>
					</el-form-item>
					<el-form-item label="故事描述:">
						<el-input size="mini" type="textarea" :rows="3" placeholder="请输入故事描述" v-model="addform.content">
						</el-input>
					</el-form-item>
					<el-form-item label="是否显示:">
						<el-radio-group v-model="addform.status">
							<el-radio :label="item.type" v-for="(item, index) in reviewStatus" :key="index">
								{{ item.title }}
							</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-form>
			</template>

			<!-- 修改计划 -->
			<template v-else>
				<el-form :model="editform" label-position="right" label-width="120px">
					<el-form-item label="故事首图" prop="matImg">
						<el-button @click="chooseRadio(2)" type="primary" size="mini" style="margin-bottom: 10px;">
							图片库上传
						</el-button>
						<el-upload class="hide" :action="uploadUrl" :multiple="true" list-type="picture-card" :limit="1"
							:on-success="getPictrueURL" accept=".jpg,.png,.jpeg,.mp4,.avi" :file-list="fileList"
							:on-remove="handleRemove" :on-error="handleError">
							<i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
					<el-form-item label="故事标题:">
						<el-input size="mini" :rows="5" placeholder="请输故事标题" v-model="editform.title">
						</el-input>
					</el-form-item>
					<el-form-item label="故事描述:">
						<el-input size="mini" type="textarea" :rows="3" placeholder="请输入故事描述"
							v-model="editform.content">
						</el-input>
					</el-form-item>
					<el-form-item label="是否显示:">
						<el-radio-group v-model="editform.status">
							<el-radio :label="item.type" v-for="(item, index) in reviewStatus" :key="index">
								{{ item.title }}
							</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-form>
			</template>

			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click="closeUpdate">取 消</el-button>
				<el-button size="mini" type="primary" @click="addScattered()">确 定</el-button>
			</div>
		</el-dialog>
		<!--完善故事抽屉-->
		<el-drawer size="100%" title="故事上传" :visible.sync="drawer" direction="btt"
			:before-close="handleCloseDrawerModal">
			<el-row>
				<el-col :span="4" :offset="20">
					<el-button size="mini" type="primary" v-if="addStoryNav == 'first'" @click="addstoryBaseInfo(1)"
						:disabled="!!baseInfo.content || !!baseInfo.list">上传素材</el-button>
					<el-button size="mini" type="primary" v-if="addStoryNav == 'second'" @click="addstoryMatInfo(1)">
						上传素材</el-button>
					<el-button size="mini" type="primary" v-if="addStoryNav == 'third'" @click="addstoryEvaluate(1)"
						:disabled="!!EvaluateInfo.content || !!EvaluateInfo.list">上传素材</el-button>
				</el-col>
			</el-row>
			<div style="margin:20px 280px;">
				<el-tabs stretch v-model="addStoryNav" @tab-click="NavTabschange()">
					<el-tab-pane label="基础信息" name="first">
						<el-row :gutter="40" v-if="!!baseInfo.content || !!baseInfo.list">
							<el-col :span="10">
								<el-card class="box-card">
									<div slot="header" class="clearfix">
										<span>场景方案构想</span>
									</div>
									<div>
										<span>{{ baseInfo.content }}</span>
									</div>
								</el-card>
							</el-col>
							<el-col :span="10">
								<el-card class="box-card">
									<div slot="header" class="clearfix">
										<span>重点要求</span>
									</div>
									<div>
										<div style="margin-top:15px" v-for="(item, index) in baseInfo.list"
											:key="index">
											<el-tag size="mini">要求{{ index+ 1}}</el-tag><span
												style="margin-left:10px">{{ item }}</span>
										</div>
									</div>
								</el-card>
							</el-col>
							<el-col :span="4">
								<el-button type="success" icon="el-icon-edit" circle style="margin-right:20px"
									@click="addstoryBaseInfo(2)"></el-button>
								<el-button type="danger" icon="el-icon-delete" circle @click="delstoryBaseInfo()">
								</el-button>
							</el-col>
						</el-row>
						<el-row style="text-align:center;margin:20px 0" v-else>
							暂无数据
						</el-row>
					</el-tab-pane>
					<el-tab-pane label="故事素材" name="second">
						<el-row style="margin-top:30px">
							<el-tabs tab-position="left" style="height: 400px;" @tab-click="getStorymatInfo()"
								v-model="addStoryMatNav">
								<el-tab-pane v-for="(item, index) in storyStageList" :key="index" :label="item.dicDesc"
									:name="item.dicDesc">
									<!-- table  -->
									<div style="padding:0 30px">
										<el-table :data="matdataList" height="400px">
											<el-table-column type="index" width="30"></el-table-column>
											<el-table-column prop="info" label="说明" />
											<el-table-column prop="type_name" label="图片类型" />
											<el-table-column prop="jd_name" label="阶段" />
											<el-table-column label="素材图片">
												<template slot-scope="scope">
													<el-image
														:src="scope.row.defaultPic + '?x-oss-process=image/resize,w_50'"
														style="width: 50px; height: 50px" fit="cover"
														:preview-src-list="[scope.row.defaultPic]" />
												</template>
											</el-table-column>
											<el-table-column label="上传时间">
												<template slot-scope="scope">
													<span>{{ scope.row.createTime | formatDate }}</span>
												</template>
											</el-table-column>
											<el-table-column label="操作" width="300">
												<template slot-scope="scope">
													<el-button plain size="mini" type="info"
														@click="addstoryMatInfo(2, scope.row)">编辑</el-button>
													<el-button plain type="danger" size="mini"
														@click="delstoryMatInfo(scope.row.id)">删除</el-button>
												</template>
											</el-table-column>
										</el-table>
									</div>
								</el-tab-pane>
							</el-tabs>
						</el-row>
					</el-tab-pane>
					<el-tab-pane label="客户评价" name="third">
						<template v-if="!!EvaluateInfo.content || !!EvaluateInfo.list">
							<el-row>
								<el-col :span="2">
									客户评价图片：
								</el-col>
								<el-col :span="2" :offset="20">
									<el-button type="success" icon="el-icon-edit" circle style="margin-right:20px"
										@click="addstoryEvaluate(2)"></el-button>
									<el-button type="danger" icon="el-icon-delete" circle @click="deltoEvaluate()">
									</el-button>
								</el-col>
							</el-row>
							<el-row class="scroll-view"
								style="background-color:#f7f7f7;width:fit-content;max-width:100%;">
								<el-image style="width: 100px; height: 100px;margin-right:20px"
									v-for="(item, index) in EvaluateInfo.list" :key="index" :src="item"
									v-show="item != ''" :preview-src-list="[item]" fit="scale-down"></el-image>
							</el-row>
							<el-row>
								客户评价文案：
							</el-row>
							<el-row>
								<el-col :span="6">
									<el-input type="textarea" size="mini" disabled :rows="5"
										v-model="EvaluateInfo.content" />
								</el-col>
							</el-row>
						</template>
						<el-row style="text-align:center;margin:20px 0" v-else>
							暂无数据
						</el-row>
					</el-tab-pane>
				</el-tabs>
			</div>
		</el-drawer>
		<!-- 添加其他信息的弹框 -->
		<el-dialog :title="isaddJBXX == 1 ? '添加基本信息' : '修改基本信息'" :visible.sync="dialogVisibleJBXX"
			:before-close="closeUpdateJBXX" width="25%">
			<!-- 新增基本信息 -->
			<template v-if="isaddJBXX == 1">
				<el-form :model="addbaseInfoform" label-position="right" label-width="120px">
					<el-form-item label="场景方案构想:">
						<el-input type="textarea" size="mini" :rows="5" placeholder="请输入场景方案构想"
							v-model="addbaseInfoform.content">
						</el-input>
					</el-form-item>
					<el-form-item label="重点要求:">
						<el-button type="primary" plain size="mini" @click="addListItem">添加重点要求</el-button>
					</el-form-item>
					<!-- 关联商品列表 -->
					<div class="scroll-view">
						<el-form-item v-for="(item, index) in addbaseInfoform.list" :key="index"
							:label="'要求' + (index + 1)">
							<el-col>
								<el-input size="mini" :rows="3" placeholder="请填写重点要求"
									v-model="addbaseInfoform.list[index]">
								</el-input>
								<el-button type="danger" size="mini" icon="el-icon-delete" circle style="margin:10px"
									@click="delListItem(index)"></el-button>
							</el-col>
						</el-form-item>
					</div>
				</el-form>
			</template>

			<!-- 修改基本信息 -->
			<template v-else>
				<el-form :model="editbaseInfoform" label-position="right" label-width="120px">
					<el-form-item label="场景方案构想:">
						<el-input type="textarea" size="mini" :rows="5" placeholder="请输入场景方案构想"
							v-model="editbaseInfoform.content">
						</el-input>
					</el-form-item>
					<el-form-item label="重点要求:">
						<el-button type="primary" plain size="mini" @click="addListItem">添加重点要求</el-button>
					</el-form-item>
					<!-- 关联商品列表 -->
					<div class="scroll-view">
						<el-form-item v-for="(item, index) in editbaseInfoform.list" :key="index"
							:label="'要求' + (index + 1)">
							<el-col>
								<el-input size="mini" :rows="3" placeholder="请填写重点要求"
									v-model="editbaseInfoform.list[index]">
								</el-input>
								<el-button type="danger" size="mini" icon="el-icon-delete" circle style="margin:10px"
									@click="delListItem(index)"></el-button>
							</el-col>
						</el-form-item>
					</div>
				</el-form>
			</template>

			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click="closeUpdate">取 消</el-button>
				<el-button size="mini" type="primary" @click="addtobaseinfo()">确 定</el-button>
			</div>
		</el-dialog>
		<!-- 故事階段素材 -->
		<el-dialog :title="isaddGSSC == 1 ? '添加故事素材' : '修改故事素材'" :visible.sync="dialogVisibleGSSC"
			:before-close="closeUpdateGSSC" width="25%">
			<!-- 新增基本信息 -->
			<template v-if="isaddGSSC == 1">
				<el-form :model="addmatInfoform" label-position="right" label-width="120px">
					<!-- <el-form-item label="图片/视频" prop="matImg">
						<div class="flex">
							<el-upload :action="uploadUrl" :multiple="true" list-type="picture-card" :limit="9"
								:on-success="getPictrueURLGSSC" accept=".jpg,.png,.mp4,.avi" :file-list="fileListGSSC"
								:on-preview="handlePictureCardPreviewGSSC" :on-remove="handleRemoveGSSC"
								:on-error="handleErrorGSSC">
								<i class="el-icon-plus"></i>
								<div slot="tip" class="el-upload__tip">
									只能上传jpg/png文件，最多上传9张图片
								</div>
								 <div slot="tip" class="el-upload__tip">
								当前已上传：{{addmatInfoform.matImg.split(",").length-1}}
							</div> -->
					<!-- </el-upload>
							<el-button @click="openImg(3)" type="text">图片库上传</el-button>
						</div>
					</el-form-item> -->
					<el-form-item label="图片/视频" prop="matImg">
						<el-button @click="chooseRadio(3)" type="primary" size="mini" style="margin-bottom: 10px;">图片库上传
						</el-button>
						<el-upload class="hide" :action="uploadUrl" :multiple="true" list-type="picture-card" :limit="9"
							:file-list="fileListGSSC" :on-preview="handlePictureCardPreviewGSSC"
							:on-remove="handleRemoveGSSC">
							<i class="el-icon-plus"></i>
							<div slot="tip" class="el-upload__tip">
								只能上传jpg/png文件，最多上传9张图片
							</div>
						</el-upload>
					</el-form-item>
					<el-form-item label="图片类型:">
						<el-select placeholder="请选择" clearable size="mini" v-model="addmatInfoform.type">
							<el-option v-for="item in imageTypeList" :key="item.dicId" :label="item.dicDesc"
								:value="item.dicId" />
						</el-select>
					</el-form-item>
					<el-form-item label="阶段:">
						<el-select placeholder="请选择" clearable size="mini" v-model="addmatInfoform.jd">
							<el-option v-for="item in storyStageList" :key="item.dicId" :label="item.dicDesc"
								:value="item.dicId" />
						</el-select>
					</el-form-item>
					<el-form-item label="说明:">
						<el-input type="textarea" size="mini" :rows="5" placeholder="请输入说明"
							v-model="addmatInfoform.info">
						</el-input>
					</el-form-item>
				</el-form>
			</template>

			<!-- 修改基本信息 -->
			<template v-else>
				<el-form :model="editmatInfoform" label-position="right" label-width="120px">
					<!--<el-form-item label="图片/视频" prop="matImg">
						<div class="flex2">
							<el-upload :action="uploadUrl" :multiple="true" list-type="picture-card" :limit="9"
								:on-success="getPictrueURLGSSC" accept=".jpg,.png,.mp4,.avi" :file-list="fileListGSSC"
								:on-preview="handlePictureCardPreviewGSSC" :on-remove="handleRemoveGSSC"
								:on-error="handleErrorGSSC">
								<i class="el-icon-plus"></i>
								<div slot="tip" class="el-upload__tip">
									只能上传jpg/png文件，最多上传9张图片
								</div>
								 <div slot="tip" class="el-upload__tip">
								当前已上传：{{editmatInfoform.matImg.split(",").length-1}}
							</div>
							</el-upload>
							<el-button @click="openImg(4)" type="text">图片库上传</el-button>
						</div>
					</el-form-item> -->

					<el-form-item label="图片/视频" prop="matImg">
						<el-button @click="chooseRadio(4)" type="primary" size="mini" style="margin-bottom: 10px;">图片库上传
						</el-button>
						<el-upload class="hide" :action="uploadUrl" :multiple="true" list-type="picture-card" :limit="9"
							:on-success="getPictrueURLGSSC" accept=".jpg,.png,.mp4,.avi" :file-list="fileListGSSC"
							:on-preview="handlePictureCardPreviewGSSC" :on-remove="handleRemoveGSSC"
							:on-error="handleErrorGSSC">
							<i class="el-icon-plus"></i>
							<div slot="tip" class="el-upload__tip">
								只能上传jpg/png文件，最多上传9张图片
							</div>
						</el-upload>
					</el-form-item>

					<el-form-item label="图片类型:">
						<el-select placeholder="请选择" clearable size="mini" v-model="editmatInfoform.type">
							<el-option v-for="item in imageTypeList" :key="item.dicId" :label="item.dicDesc"
								:value="item.dicId" />
						</el-select>
					</el-form-item>
					<el-form-item label="阶段:">
						<el-select placeholder="请选择" clearable size="mini" v-model="editmatInfoform.jd">
							<el-option v-for="item in storyStageList" :key="item.dicId" :label="item.dicDesc"
								:value="item.dicId" />
						</el-select>
					</el-form-item>
					<el-form-item label="说明:">
						<el-input type="textarea" size="mini" :rows="5" placeholder="请输入说明"
							v-model="editmatInfoform.info">
						</el-input>
					</el-form-item>
				</el-form>
			</template>

			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click="closeUpdateGSSC">取 消</el-button>
				<el-button size="mini" type="primary" @click="addtoMatinfo()">确 定</el-button>
			</div>
		</el-dialog>

		<!-- 客户评价 -->
		<el-dialog :title="isaddEvaluate == 1 ? '添加客户评价' : '修改客户评价'" :visible.sync="dialogVisibleEvaluate"
			:before-close="closeUpdateEvaluate" width="25%">
			<!-- 新增基本信息 -->
			<template v-if="isaddEvaluate == 1">
				<el-form :model="addEvaluateform" label-position="right" label-width="120px">
					<!--<el-form-item label="图片/视频" prop="matImg">
						<div class="flex2">
							<el-upload :action="uploadUrl" :multiple="true" list-type="picture-card" :limit="9"
								:on-success="getPictrueURLEvaluate" accept=".jpg,.png,.mp4,.avi"
								:file-list="fileListEvaluate" :on-preview="handlePictureCardPreviewEvaluate"
								:on-remove="handleRemoveEvaluate" :on-error="handleErrorEvaluate">
								<i class="el-icon-plus"></i>
								<div slot="tip" class="el-upload__tip">
									只能上传jpg/png文件，最多上传9张图片
								</div>
								 <div slot="tip" class="el-upload__tip">
								当前已上传：{{addEvaluateform.matImg.split(",").length-1}}
							</div>
							</el-upload>
							<el-button type="text" @click="openImg(5)">图片库上传</el-button>
						</div>
					</el-form-item> -->
					<el-form-item label="图片/视频" prop="matImg">
						<el-button @click="chooseRadio(5)" type="primary" size="mini" style="margin-bottom: 10px;">图片库上传
						</el-button>
						<el-upload class="hide" :action="uploadUrl" :multiple="true" list-type="picture-card" :limit="9"
							:on-success="getPictrueURLEvaluate" accept=".jpg,.png,.mp4,.avi"
							:file-list="fileListEvaluate" :on-preview="handlePictureCardPreviewEvaluate"
							:on-remove="handleRemoveEvaluate" :on-error="handleErrorEvaluate">
							<i class="el-icon-plus"></i>
							<div slot="tip" class="el-upload__tip">
								只能上传jpg/png文件，最多上传9张图片
							</div>
						</el-upload>
					</el-form-item>
					<el-form-item label="文案:">
						<el-input type="textarea" size="mini" :rows="5" placeholder="请输入文案"
							v-model="addEvaluateform.content">
						</el-input>
					</el-form-item>
				</el-form>
			</template>

			<!-- 修改基本信息 -->
			<template v-else>
				<el-form :model="editEvaluateform" label-position="right" label-width="120px">
					<!-- <el-form-item label="图片/视频" prop="matImg">
						<div class="flex2">
							<el-upload :action="uploadUrl" :multiple="true" list-type="picture-card" :limit="9"
								:on-success="getPictrueURLEvaluate" accept=".jpg,.png,.mp4,.avi"
								:file-list="fileListEvaluate" :on-preview="handlePictureCardPreviewEvaluate"
								:on-remove="handleRemoveEvaluate" :on-error="handleErrorEvaluate">
								<i class="el-icon-plus"></i>
								<div slot="tip" class="el-upload__tip">
									只能上传jpg/png文件，最多上传9张图片
								</div>
								<div slot="tip" class="el-upload__tip">
								当前已上传：{{editEvaluateform.matImg.split(",").length-1}}
							</div>
							</el-upload>
							<el-button @click="openImg(6)" type="text">图片库上传</el-button>
						</div>
					</el-form-item> -->
					<el-form-item label="图片/视频" prop="matImg">
						<el-button @click="chooseRadio(6)" type="primary" size="mini" style="margin-bottom: 10px;">图片库上传
						</el-button>
						<el-upload class="hide" :action="uploadUrl" :multiple="true" list-type="picture-card" :limit="9"
							:on-success="getPictrueURLEvaluate" accept=".jpg,.png,.mp4,.avi"
							:file-list="fileListEvaluate" :on-preview="handlePictureCardPreviewEvaluate"
							:on-remove="handleRemoveEvaluate" :on-error="handleErrorEvaluate">
							<i class="el-icon-plus"></i>
							<div slot="tip" class="el-upload__tip">
								只能上传jpg/png文件，最多上传9张图片
							</div>
						</el-upload>
					</el-form-item>
					<el-form-item label="文案:">
						<el-input type="textarea" size="mini" :rows="5" placeholder="请输入文案"
							v-model="editEvaluateform.content">
						</el-input>
					</el-form-item>
				</el-form>
			</template>

			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click="closeUpdateEvaluate">取 消</el-button>
				<el-button size="mini" type="primary" @click="addtoEvaluate()">确 定</el-button>
			</div>
		</el-dialog>
		<el-drawer title="图片选择" :visible.sync="drawer2" direction="rtl" size="40%">
			<SelectPicture :imgNum="imgNum" @imgList='getImg' />
		</el-drawer>
	</el-row>
</template>

<script>
	import {
		getGroupList
	} from "../../../util/index.js";
	import httpClient from "../../../util/request.js";
	import SelectPicture from '../../../components/SelectPicture/index.vue'
	var vm;
	export default {
		components: {
			SelectPicture
		},
		data() {
			return {
				radioValue: '0',
				imgNum: 1,
				drawer2: false,
				addStoryMatNav: '',
				addStoryNav: 'first',
				drawer: false,
				uploadUrl: httpClient.imgUrl,
				dialogVisible: false,
				tableHeight: window.innerHeight - 300,
				tableData: [],
				total: 0,
				pageSize: 10,
				pageNum: 1,
				pageSizes: [10, 20, 30, 40, 50],
				imageTypeList: [],
				storyStageList: [],
				searchform: {
					content: "",
					status: "",
				},
				addform: {
					matImg: "",
					title: "",
					content: "",
					status: -1,
				},
				editform: {
					id: "",
					matImg: "",
					title: "",
					content: "",
					status: -1,
				},
				searchform: {
					content: "",
					status: "",
				},
				reviewStatus: [{
						title: "显示",
						type: 0,
					},
					{
						title: "隐藏",
						type: 1,
					},
				],
				isadd: "", //判断添加还是编辑
				fileList: [],
				selectStoryId: '',
				// 基本信息
				isaddJBXX: "",
				dialogVisibleJBXX: false,
				addbaseInfoform: {
					content: '',
					list: []
				},
				editbaseInfoform: {
					id: '',
					content: '',
					list: []
				},
				baseInfo: {},
				//故事素材
				isaddGSSC: "",
				dialogVisibleGSSC: false,
				addmatInfoform: {
					type: '',
					matImg: '',
					jd: '',
					info: '',
				},
				editmatInfoform: {
					id: '',
					type: '',
					matImg: '',
					jd: '',
					info: ''
				},
				fileListGSSC: [],
				matdataList: [],
				//客户评价
				isaddEvaluate: '',
				dialogVisibleEvaluate: false,
				addEvaluateform: {
					matImg: '',
					content: ''
				},
				editEvaluateform: {
					id: '',
					matImg: '',
					content: ''
				},
				fileListEvaluate: [],
				EvaluateInfo: {}
			};
			scType: 0
		},
		mounted() {
			vm = this;
			this.getImageType();
			this.getStoryStage();
			this.getTable();
		},
		filters: {
			// 使用计算属性
			formatDate(val) {
				return val ? vm.$moment(val).format("YYYY-MM-DD HH:MM:SS") : "";
			},
		},
		methods: {
			chooseRadio(num) {
				console.log(num)

				this.drawer2 = true
				this.scType = num
				if (num == 1 || num == 2) {
					this.imgNum = 1;
				} else {
					this.imgNum = 9
				}

			},
			openImg(num) {

			},
			getImg(e) {
				console.log(this.scType);
				var arr = e.split(',')
				if (this.scType == 1) {
					this.addform.matImg = ''
					this.addform.matImg = e;
					this.fileList = [];
					arr.forEach(item => {
						this.fileList.push({
							url: item
						})
					})
				}
				if (this.scType == 2) {
					this.editform.matImg = ''
					this.editform.matImg = e
					this.fileList = [];
					arr.forEach(item => {
						this.fileList.push({
							url: item
						})
					})
				}
				if (this.scType == 3) {
					this.addmatInfoform.matImg = ''
					this.addmatInfoform.matImg = e
					this.fileListGSSC = [];
					arr.forEach(item => {
						this.fileListGSSC.push({
							url: item
						})
					})
					console.log(this.fileListGSSC);
				}
				if (this.scType == 4) {
					this.editmatInfoform.matImg = ''
					this.editmatInfoform.matImg = e
					this.fileListGSSC = [];
					arr.forEach(item => {
						this.fileListGSSC.push({
							url: item
						})
					})
				}
				if (this.scType == 5) {
					this.addEvaluateform.matImg = ''
					this.addEvaluateform.matImg = e
					this.fileListEvaluate = [];
					arr.forEach(item => {
						this.fileListEvaluate.push({
							url: item
						})
					})
				}
				if (this.scType == 6) {
					this.editEvaluateform.matImg = ''
					this.editEvaluateform.matImg = e
					this.fileListEvaluate = [];
					arr.forEach(item => {
						this.fileListEvaluate.push({
							url: item
						})
					})
				}
				this.drawer2 = false
			},
			NavTabschange() {
				if (this.addStoryNav == 'first') {
					this.getStoryBaseInfo()
				}
				if (this.addStoryNav == 'second') {
					this.getStorymatInfo()
				}
				if (this.addStoryNav == 'third') {
					this.getCustomerEvaluate()
				}
			},
			//获取图片类型
			getImageType() {
				getGroupList("私定故事", "图片类型").then((res) => {
					this.imageTypeList = res;
				});
			},

			//获取故事阶段
			getStoryStage() {
				getGroupList("私定故事", "故事阶段").then((res) => {
					this.storyStageList = res;
					this.addStoryMatNav = res[0].dicDesc;
				});
			},

			//获取数据列表
			getTable() {
				var data = {
					content: this.content,
					status: this.status,
				};
				this.$http
					.post(
						`/api/source/sysPrivateStory/select?pageNum=${this.pageNum}&pageSize=${this.pageSize}`,
						data
					)
					.then((res) => {
						if (res.data.status == 0) {
							console.log(res, "");
							this.tableData = res.data.data.list;
							this.total = res.data.data.total;
						} else {
							this.$message({
								type: "error",
								message: "系统繁忙，请稍后再试~~",
							});
						}
					});
			},

			//pagesize改变
			handleSizeChange(val) {
				this.pageNum = 1;
				this.pageSize = val;
				this.getTable();
			},

			//页码改变
			handleCurrentChange(val) {
				this.pageNum = val;
				this.getTable();
			},

			//搜索
			search() {
				this.content = this.searchform.content;
				this.status = this.searchform.status;
				this.pageNum = 1;
				this.getTable();
			},

			//清空
			Empty() {
				this.content = this.searchform.content = "";
				this.status = this.searchform.status = "";
				this.search();
			},

			//弹框取消
			closeUpdate() {
				this.addform = {
					matImg: "",
					title: "",
					content: "",
					status: -1,
				};
				(this.editform = {
					id: "",
					matImg: "",
					title: "",
					content: "",
					status: -1,
				}),
				(this.fileList = []);
				this.dialogVisible = false;
			},

			//确定
			addScattered() {
				let _this = this;
				//添加
				if (this.isadd == 1) {
					if (
						this.addform.matImg == "" ||
						this.addform.title.trim() == "" ||
						this.addform.content.trim() == "" ||
						this.addform.status < 0
					) {
						return this.$message({
							type: "error",
							message: "请填写完整故事再提交~~",
						});
					}
					var data = {
						title: this.addform.title,
						content: this.addform.content,
						pic: this.addform.matImg,
						status: this.addform.status,
						deleteStatus: 0,
					};

					this.$http
						.post(`/api/source/sysPrivateStory/insert`, data)
						.then((res) => {
							if (res.data) {
								this.$message({
									type: "success",
									message: "添加私定故事成功！！",
								});
								this.getTable();
								_this.closeUpdate();
							} else {
								this.$message({
									type: "error",
									message: "系统繁忙，请稍后再试~~",
								});
							}
						});
				}
				//修改
				if (this.isadd == 2) {
					var data = {
						id: this.editform.id,
						title: this.editform.title,
						content: this.editform.content,
						pic: this.editform.matImg,
						status: this.editform.status,
					};
					this.$http
						.post(`/api/source/sysPrivateStory/update`, data)
						.then((res) => {
							if (res.data) {
								this.$message({
									type: "success",
									message: "修改私定故事成功！！",
								});
								_this.closeUpdate();
								this.getTable();
							} else {
								this.$message({
									type: "error",
									message: "系统繁忙，请稍后再试~~",
								});
							}
						});
				}
			},

			//添加故事
			addStorage(type, val) {
				this.isadd = type;
				if (type == 2) {
					// 編輯
					this.editform.id = val.id;
					this.editform.matImg = val.pic;
					this.editform.title = val.title;
					this.editform.content = val.content;
					this.editform.status = val.status;
					this.fileList = [{
						name: val.title,
						url: val.pic,
					}, ];
				}
				this.dialogVisible = true;
			},
			// 添加图片的++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
			// 获取图片地址，调用接口后端返回上传地址
			getPictrueURL(response, file, fileList) {
				this.addform.matImg = response.data;
			},
			// 图片上传框删除一个图片
			handleRemove(file, fileList) {
				this.addform.matImg = "";
			},
			handleError(err, file, fileList) {
				err = err + "a";
				if (err.search("413") != -1) {
					this.$message.error("抱歉，文件过大，无法上传");
				} else {
					this.$message.error("抱歉，上传文件失败，请稍等片刻再次尝试");
				}
			},
			// 修改图片的++++++++++++++++++++++++++++++++++++++++++++++++++++
			// 获取图片地址，调用接口后端返回上传地址
			getPictrueURL1(response, file, fileList) {
				this.editform.matImg = response.data;
			},
			// 图片上传框删除一个图片
			handleRemove1(file, fileList) {
				this.editform.matImg = "";
				this.fileList = [];
			},
			handleError1(err, file, fileList) {
				err = err + "a";
				if (err.search("413") != -1) {
					this.$message.error("抱歉，文件过大，无法上传");
				} else {
					this.$message.error("抱歉，上传文件失败，请稍等片刻再次尝试");
				}
			},
			PerfectStory(val) {
				this.selectStoryId = val.id
				this.NavTabschange()
				this.drawer = true;
			},
			//关闭完善故事弹窗
			handleCloseDrawerModal() {
				this.addStoryNav = 'first'
				this.baseInfo = {}
				this.EvaluateInfo = {}
				this.matdataList = []
				this.drawer = false;
			},
			// +++++++++++++++++++  基本信息+++++++++++++++++++++++++++++++++++++++++++++++++++
			//查询私定故事基本信息
			getStoryBaseInfo() {
				this.$http
					.post(
						`/api/source/sysPrivateStory/selectBase`, {
							storyId: this.selectStoryId
						}
					)
					.then((res) => {
						if (res.data.status == 0) {
							console.log(res, "私定故事基本信息");
							var list = res.data.data
							if (!list[0]) {
								this.baseInfo = {}
							} else {
								this.baseInfo = {
									content: list[0].cjgx,
									list: list[0].ydms.split('&'),
									id: list[0].id
								}
							}
						} else {
							this.$message({
								type: "error",
								message: "系统繁忙，请稍后再试~~",
							});
						}
					});
			},
			//打开添加故事弹框
			addstoryBaseInfo(type) {
				this.isaddJBXX = type
				if (type == 2) {
					//编辑私定故事
					this.editbaseInfoform = {
						id: this.baseInfo.id,
						content: this.baseInfo.content,
						list: this.baseInfo.list
					}
				}
				this.dialogVisibleJBXX = true
			},
			closeUpdateJBXX() {
				this.addbaseInfoform = {
						content: '',
						list: []
					},
					this.editbaseInfoform = {
						id: '',
						content: '',
						list: []
					}
				this.dialogVisibleJBXX = false
			},
			addListItem() {
				if (!this.editbaseInfoform.list) {
					this.editbaseInfoform.list = []
				}
				let item = '';
				if (this.isaddJBXX == 1) {
					let list = [...this.addbaseInfoform.list];
					list.push(item);
					this.addbaseInfoform.list = list;
				} else {
					let list = [...this.editbaseInfoform.list];
					list.push(item);
					this.editbaseInfoform.list = list;
				}
			},
			delListItem(index) {
				if (this.isaddJBXX == 1) {
					let list = [...this.addbaseInfoform.list];
					list.splice(index, 1);
					this.addbaseInfoform.list = list;
				} else {
					let list = [...this.editbaseInfoform.list];
					list.splice(index, 1);
					this.editbaseInfoform.list = list;
				}
			},
			//添加基本信息确定
			addtobaseinfo() {
				let _this = this;
				//添加
				if (this.isaddJBXX == 1) {
					if (
						!this.addbaseInfoform.content.trim() ||
						this.addbaseInfoform.list.length <= 0

					) {
						return this.$message({
							type: "error",
							message: "请填写完整基本信息再提交~~",
						});
					}
					let arr = [...this.addbaseInfoform.list]
					let resultList = arr.filter(item => item !== '')
					var data = {
						cjgx: this.addbaseInfoform.content,
						ydms: resultList.join('&'),
						status: 0,
						deleteStatus: 0,
						storyId: this.selectStoryId
					};

					this.$http
						.post(`/api/source/sysPrivateStory/insertBase`, data)
						.then((res) => {
							if (res.data) {
								this.$message({
									type: "success",
									message: "添加基本信息成功！！",
								});
								this.getStoryBaseInfo();
								_this.closeUpdateJBXX();
							} else {
								this.$message({
									type: "error",
									message: "系统繁忙，请稍后再试~~",
								});
							}
						});
				}
				//修改
				if (this.isaddJBXX == 2) {
					let arr = [...this.editbaseInfoform.list]
					let resultList = arr.filter(item => item.productId !== '')
					var data = {
						id: this.editbaseInfoform.id,
						cjgx: this.editbaseInfoform.content,
						ydms: resultList.join('&'),
						status: 0,
						storyId: this.selectStoryId
					};

					this.$http
						.post(`/api/source/sysPrivateStory/updateBase`, data)
						.then((res) => {
							if (res.data) {
								this.$message({
									type: "success",
									message: "修改基本信息成功！！",
								});
								this.getStoryBaseInfo();
								_this.closeUpdateJBXX();
							} else {
								this.$message({
									type: "error",
									message: "系统繁忙，请稍后再试~~",
								});
							}
						});
				}
			},
			//删除基本信息
			delstoryBaseInfo() {
				this.$confirm('此操作将删除该条基本信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					this.$http.get(`/api/source/sysPrivateStory/deleteByPkBase/${this.baseInfo.id}`).then(res => {
						if (res.data) {
							this.$message({
								type: 'success',
								message: '操作成功'
							});
							this.getStoryBaseInfo()
						} else {
							this.$message({
								type: 'error',
								message: '系统繁忙，请稍后再试~~'
							});
						}
					}).catch(error => {});
				});
			},
			// +++++++++++++++++++++++++++图片素材+++++++++++++++++++++++++++++++++++
			getStorymatInfo() {
				var that = this
				let list = [...this.storyStageList]
				let jd = list.filter(item => item.dicDesc == this.addStoryMatNav)[0].dicId
				this.$http
					.post(
						`/api/source/sysPrivateStory/selectMat`, {
							jd: jd,
							storyId: this.selectStoryId
						}
					)
					.then((res) => {
						if (res.data.status == 0) {
							console.log(res, "私定故事素材");
							let list = res.data.data
							if (list.length > 0) {

								list.forEach(element => {
									element.defaultPic = element.pic.split(',')[0]
									element.jd_name = [...that.storyStageList].filter(item => item.dicId ==
										element.jd)[0].dicDesc
									element.type_name = [...that.imageTypeList].filter(item => item.dicId ==
										element.type)[0].dicDesc

								});
							}
							this.matdataList = list
						} else {
							this.$message({
								type: "error",
								message: "系统繁忙，请稍后再试~~",
							});
						}
					});
			},
			addstoryMatInfo(type, val) {
				this.isaddGSSC = type
				if (type == 2) {
					let list = []
					this.editmatInfoform = {
						type: val.type,
						matImg: val.pic,
						jd: val.jd,
						info: val.info,
						id: val.id
					}
					val.pic.split(',').forEach(item => {
						list.push({
							url: item
						})
					})
					// list.splice(list.length-1,1)
					// console.log(list,'编辑的图片');
					this.fileListGSSC = [...list]
				}
				this.dialogVisibleGSSC = true
			},
			closeUpdateGSSC() {
				this.addmatInfoform = {
						type: '',
						matImg: '',
						jd: '',
						info: '',
					},
					this.editmatInfoform = {
						type: '',
						matImg: '',
						jd: '',
						info: ''
					},
					this.fileListGSSC = []
				this.dialogVisibleGSSC = false
			},
			getPictrueURLGSSC(response, file, fileList) {
				if (this.isaddGSSC == 1) {
					if (this.addmatInfoform.matImg[this.addmatInfoform.matImg.length - 1] == ",") {
						this.addmatInfoform.matImg += response.data + ",";
					} else {
						if (this.addmatInfoform.matImg.length > 0) {
							this.addmatInfoform.matImg += "," + response.data + ",";
						} else {
							this.addmatInfoform.matImg += response.data + ",";
						}
					}
				} else {
					if (this.editmatInfoform.matImg[this.editmatInfoform.matImg.length - 1] == ",") {
						this.editmatInfoform.matImg += response.data + ",";
					} else {
						if (this.editmatInfoform.matImg.length > 0) {
							this.editmatInfoform.matImg += "," + response.data + ",";
						} else {
							this.editmatInfoform.matImg += response.data + ",";
						}
					}
				}

			},
			handleRemoveGSSC(file, fileList) {
				if (this.isaddGSSC == 1) {
					let files = this.addmatInfoform.matImg.split(",");
					files.splice(files.indexOf(file.url), 1);
					this.addmatInfoform.matImg = files.length === 0 ? "" : files.join(",");
				} else {
					let files = this.editmatInfoform.matImg.split(",");
					files.splice(files.indexOf(file.url), 1);
					this.editmatInfoform.matImg = files.length === 0 ? "" : files.join(",");
				}
			},
			//上传图片预览
			handlePictureCardPreviewGSSC(file) {

			},
			handleErrorGSSC(err, file, fileList) {
				err = err + "a";
				if (err.search("413") != -1) {
					this.$message.error("抱歉，文件过大，无法上传");
				} else {
					this.$message.error("抱歉，上传文件失败，请稍等片刻再次尝试");
				}
			},
			//添加图片素材  确地
			addtoMatinfo() {
				let _this = this;
				//添加
				if (this.isaddGSSC == 1) {
					if (
						!this.addmatInfoform.info.trim() ||
						this.addmatInfoform.matImg == '' ||
						this.addmatInfoform.type == '' ||
						this.addmatInfoform.jd == ''

					) {
						return this.$message({
							type: "error",
							message: "请填写完整图片素材再提交~~",
						});
					}

					var data = {
						pic: this.addmatInfoform.matImg,
						type: this.addmatInfoform.type,
						jd: this.addmatInfoform.jd,
						info: this.addmatInfoform.info,
						status: 0,
						deleteStatus: 0,
						storyId: this.selectStoryId
					};

					this.$http
						.post(`/api/source/sysPrivateStory/insertMat`, data)
						.then((res) => {
							if (res.data) {
								this.$message({
									type: "success",
									message: "添加图片素材成功！！",
								});
								this.getStorymatInfo();
								_this.closeUpdateGSSC();
							} else {
								this.$message({
									type: "error",
									message: "系统繁忙，请稍后再试~~",
								});
							}
						});
				}
				//修改
				if (this.isaddGSSC == 2) {
					var str = this.editmatInfoform.matImg
					if (str[str.length - 1] == ',') {
						str = str.slice(0, str.length - 1)
					}
					var data = {
						pic: str,
						type: this.editmatInfoform.type,
						jd: this.editmatInfoform.jd,
						info: this.editmatInfoform.info,
						status: 0,
						id: this.editmatInfoform.id,
						storyId: this.selectStoryId
					};

					this.$http
						.post(`/api/source/sysPrivateStory/updateMat`, data)
						.then((res) => {
							if (res.data) {
								this.$message({
									type: "success",
									message: "修改图片素材成功！！",
								});
								this.getStorymatInfo();
								_this.closeUpdateGSSC();
							} else {
								this.$message({
									type: "error",
									message: "系统繁忙，请稍后再试~~",
								});
							}
						});
				}
			},

			delstoryMatInfo(id) {
				this.$confirm('此操作将删除该条图片素材, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					this.$http.get(`/api/source/sysPrivateStory/deleteByPkMat/${id}`).then(res => {
						if (res.data) {
							this.$message({
								type: 'success',
								message: '操作成功'
							});
							this.getStorymatInfo();
						} else {
							this.$message({
								type: 'error',
								message: '系统繁忙，请稍后再试~~'
							});
						}
					}).catch(error => {});
				});
			},
			// +++++++++++++++++++++++++++++++++ 客户评价 +++++++++++++++++++++++++++++++++++
			// 获取客户评价
			getCustomerEvaluate() {
				var that = this
				this.$http
					.post(
						`/api/source/sysPrivateStory/selectEvaluate`, {
							storyId: this.selectStoryId
						}
					)
					.then((res) => {
						if (res.data.status == 0) {
							console.log(res, "客戶评价");
							var list = res.data.data
							if (!list[0]) {
								this.EvaluateInfo = {}
							} else {
								this.EvaluateInfo = {
									content: list[0].content,
									list: list[0].pic.split(','),
									id: list[0].id
								}
							}
						} else {
							this.$message({
								type: "error",
								message: "系统繁忙，请稍后再试~~",
							});
						}
					});
			},
			//打开添加弹框
			addstoryEvaluate(type) {
				this.isaddEvaluate = type
				if (type == 2) {
					let list = []
					this.editEvaluateform = {
						content: this.EvaluateInfo.content,
						matImg: this.EvaluateInfo.list.join(','),
						id: this.EvaluateInfo.id
					}
					this.EvaluateInfo.list.forEach(item => {
						list.push({
							url: item
						})
					})
					// list.splice(list.length-1,)
					// console.log(list,'编辑的图片');
					this.fileListEvaluate = [...list]
				}
				this.dialogVisibleEvaluate = true
			},

			handlePictureCardPreviewEvaluate() {

			},

			getPictrueURLEvaluate(response, file, fileList) {

				if (this.isaddEvaluate == 1) {
					if (this.addEvaluateform.matImg[this.addEvaluateform.matImg.length - 1] == ",") {
						this.addEvaluateform.matImg += response.data + ",";
					} else {
						if (this.addEvaluateform.matImg.length > 0) {
							this.addEvaluateform.matImg += "," + response.data + ",";
						} else {
							this.addEvaluateform.matImg += response.data + ",";
						}
					}
				} else {
					if (this.editEvaluateform.matImg[this.editEvaluateform.matImg.length - 1] == ",") {
						this.editEvaluateform.matImg += response.data + ",";
					} else {
						if (this.editEvaluateform.matImg.length > 0) {
							this.editEvaluateform.matImg += "," + response.data + ",";
						} else {
							this.editEvaluateform.matImg += response.data + ",";
						}
					}
				}
			},

			handleRemoveEvaluate(file) {
				if (this.isaddEvaluate == 1) {
					let files = this.addEvaluateform.matImg.split(",");
					files.splice(files.indexOf(file.url), 1);
					this.addEvaluateform.matImg = files.length === 0 ? "" : files.join(",");
				} else {
					let files = this.editEvaluateform.matImg.split(",");
					files.splice(files.indexOf(file.url), 1);
					this.editEvaluateform.matImg = files.length === 0 ? "" : files.join(",");
				}
			},

			handleErrorEvaluate(err, file, fileList) {
				err = err + "a";
				if (err.search("413") != -1) {
					this.$message.error("抱歉，文件过大，无法上传");
				} else {
					this.$message.error("抱歉，上传文件失败，请稍等片刻再次尝试");
				}
			},
			//关闭弹窗
			closeUpdateEvaluate() {
				this.addEvaluateform = {
						matImg: '',
						content: ''
					},
					this.editEvaluateform = {
						id: '',
						matImg: '',
						content: ''
					}
				this.fileListEvaluate = []
				this.dialogVisibleEvaluate = false
			},

			//点击确定
			addtoEvaluate() {
				let _this = this;
				//添加
				if (this.isaddEvaluate == 1) {
					if (
						!this.addEvaluateform.content.trim() ||
						this.addEvaluateform.matImg == ''
					) {
						return this.$message({
							type: "error",
							message: "请填写完整客户评价再提交~~",
						});
					}

					var data = {
						pic: this.addEvaluateform.matImg,
						content: this.addEvaluateform.content,
						status: 0,
						deleteStatus: 0,
						storyId: this.selectStoryId
					};

					this.$http
						.post(`/api/source/sysPrivateStory/insertEvaluate`, data)
						.then((res) => {
							if (res.data) {
								this.$message({
									type: "success",
									message: "添加客户评价成功！！",
								});
								this.getCustomerEvaluate();
								this.closeUpdateEvaluate();
							} else {
								this.$message({
									type: "error",
									message: "系统繁忙，请稍后再试~~",
								});
							}
						});
				}
				//修改
				if (this.isaddEvaluate == 2) {
					var str = this.editEvaluateform.matImg
					if (str[str.length - 1] == ',') {
						str = str.slice(0, str.length - 1)
					}
					var data = {
						pic: str,
						content: this.editEvaluateform.content,
						status: 0,
						id: this.editEvaluateform.id,
						storyId: this.selectStoryId
					};

					this.$http
						.post(`/api/source/sysPrivateStory/updateEvaluate`, data)
						.then((res) => {
							if (res.data) {
								this.$message({
									type: "success",
									message: "修改图片素材成功！！",
								});
								this.getCustomerEvaluate();
								this.closeUpdateEvaluate();
							} else {
								this.$message({
									type: "error",
									message: "系统繁忙，请稍后再试~~",
								});
							}
						});
				}
			},

			deltoEvaluate() {
				this.$confirm('此操作将删除该条图片素材, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					this.$http.get(`/api/source/sysPrivateStory/deleteByPkEvaluate/${this.EvaluateInfo.id}`).then(
						res => {
							if (res.data) {
								this.$message({
									type: 'success',
									message: '操作成功'
								});
								this.getCustomerEvaluate();
							} else {
								this.$message({
									type: 'error',
									message: '系统繁忙，请稍后再试~~'
								});
							}
						}).catch(error => {});
				});
			},
			delstoryItem(id) {
				this.$confirm('此操作将删除该条私定故事, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					this.$http.get(`/api/source/sysPrivateStory/deleteByPk/${id}`).then(res => {
						if (res.data) {
							this.$message({
								type: 'success',
								message: '操作成功'
							});
							this.getTable();
						} else {
							this.$message({
								type: 'error',
								message: '系统繁忙，请稍后再试~~'
							});
						}
					}).catch(error => {});
				});
			}
		},
	};
</script>

<style lang="less" scoped>
	.text {
		font-size: 14px;
	}

	.item {
		margin-bottom: 18px;
	}

	.clearfix:before,
	.clearfix:after {
		display: table;
		content: "";
	}

	.clearfix:after {
		clear: both
	}

	.box-card {
		width: 100%;
	}

	.scroll-view {
		max-height: 260px;
		overflow-y: scroll;
		overflow-x: scroll;
		margin: 10px;
	}

	.scroll-view::-webkit-scrollbar {
		/*滚动条整体样式*/
		width: 4px;
		/*高宽分别对应横竖滚动条的尺寸*/
		height: 1px;
	}

	.scroll-view::-webkit-scrollbar-thumb {
		/*滚动条里面小方块*/
		border-radius: 2px;
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #66b8ff;
	}

	.scroll-view::-webkit-scrollbar-track {
		/*滚动条里面轨道*/
		box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 2px;
		background: #ededed;
	}

	/deep/.hide .el-upload--picture-card {
		display: none;
	}
</style>
